import { NoteFile } from "./summary";

export interface File {
  id: string;
  fileName: string;
}

export interface ProductCount {
  "All Products": number;
  "Webex Suite": number;
  "Meetings & Messaging": number;
  "Calling Cloud": number;
  "Calling On Prem": number;
  "Contact Center": number;
  Devices: number;
  "Control Hub": number;
  Events: number;
  Webinars: number;
  Slido: number;
  Vidcast: number;
}
export interface PlaybookCounts {
  total: number;
  createdByMe: number;
  createdBySystem: number;
  customerActivity: number;
  internalActivity: number;
  management: number;
  program: number;
  productSummary: any;
  playcardProductSummary: any;
}

export interface Task {
  taskId: string;
  playbookId: string;
  taskName: string;
  taskDescription: string;
  taskNote: string;
  dueDateType: string;
  dueDateDays: number;
  createdDate: string;
  createdBy: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
  editable: boolean;
  systemGenerated: boolean;
  attachments: NoteFile[];
  attachmentIds: string[];
  taskVisibleOrgs: string[];
  taskCustomFields?: string;
}

export interface LatestActivityObject {
  activityName: string;
  accountKey: string;
  playbookId: string;
  assigneeId: string;
  assigneeRole: string;
  activityStatus: string;
  closedDate: string;
  createdDate: string;
  createdBy: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
}

export interface LatestActivity {
  latestActivity: LatestActivityObject;
}
export interface PlaybookDetail {
  id: string;
  name: string;
  type: string;
  description: string;
  priority: string;
  dueDateType: string;
  dueDateDays: number;
  allTasks: number;
  purpose: string;
  products: string[];
  createdBy: string;
  createdDate: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
  editable: boolean;
  deletable: boolean;
  attachments: NoteFile[];
  attachmentIds: string[];
  tasks: Task[];
  accountKey?: string;
  status: PlaybookStatus;
  category: (typeof PlaybookCategoryEnum)[keyof typeof PlaybookCategoryEnum] | null;
  visibleOrgs: string[] | null;
  appliable: boolean;
  reason: string | null;
  syncable: boolean;
  accountCount: number;
  activityStatus: string | null;
  attributes: LatestActivity;
  creatorName: string;
  creatorRole: string;
  customFields?: string;
  playbookId: string;
  playcards: PlaybookDetail[];
}

export const PlaybookCategoryEnum = {
  System: "SYSTEM",
  Program: "PROGRAM",
  Personal: "PERSONAL",
  Playcard: "PLAYCARD",
} as const;

export const PlaybookStatusEnum = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
  IN_PROGRESS: "In Progress",
  PENDING_APPROVAL: "Pending Approval",
  REJECTED: "Rejected",
} as const;

export type PlaybookCategory = (typeof PlaybookCategoryEnum)[keyof typeof PlaybookCategoryEnum];
export type PlaybookStatus = (typeof PlaybookStatusEnum)[keyof typeof PlaybookStatusEnum];

export const SharedFrom = {
  ACTIVITY: "Activity",
  ACTIVITY_DETAIL: "Detail",
  TASK: "Task",
  PLAYBOOK: "Playbook",
} as const;

export type SHARE_FROM_TYPE = (typeof SharedFrom)[keyof typeof SharedFrom];
